import React, { Component, Fragment } from 'react';
import { Card, Row, Col } from 'antd';
import { inject, observer } from 'mobx-react/index';
import moment from 'moment-timezone';

@inject('store')
@observer
export class LogsView extends Component {
    render() {
        const timezone = this.props.store.userStore.currentUser.timezone;

        return (
            <Fragment>
                <Row gutter={24}>
                    <Col md={24}>
                        <Card title={`Logs`} bordered={false}>
                            {this.props.store.botStore.logs.map((logRow, i) => {
                                return (
                                    <div key={logRow.time}>
                                        <span>
                                            [
                                            {moment(logRow.time)
                                                .tz(timezone)
                                                .format('DD/MM/YYYY hh:mm:ss a')}
                                            ] [{logRow.category}]
                                        </span>{' '}
                                        - {logRow.message}
                                    </div>
                                );
                            })}

                            {this.props.store.botStore.initialLogs.map((logRow, i) => {
                                return <div key={i}>{logRow}</div>;
                            })}
                        </Card>
                    </Col>
                </Row>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/LogsView/index.js